'use strict'

define [], () ->
  (RentappService, $state, $http, $timeout) ->
    restrict: "A"
    link: (scope, element, attrs) ->
      element.on 'submit', () ->
        firstInvalid = element[0].querySelector('.ng-invalid')
        if (firstInvalid)
          $timeout () ->
            $("body").find('.has-error :input:first').focus()



// WEBPACK FOOTER //
// ./directives/application/application.coffee